/**
 * Recently viewed facade: paint badge count from localStorage.
 * Full CSS/JS load on first pointerdown/keydown, or first drawer click.
 */
(() => {
  const dialog = document.getElementById("recently-viewed-drawer");
  if (!dialog) return;
  if (customElements.get("recently-viewed-component")) return;

  const loader = window.BoltFeatureLoader;
  const assets = window.BoltAssets || {};
  const cssHref = assets.recentlyViewedCss || dialog.dataset.facadeCss;
  const jsSrc = assets.recentlyViewed || dialog.dataset.facadeJs;
  if (!loader || !cssHref || !jsSrc) return;

  const STORAGE_KEY = "ks-recently-viewed";
  const CLICK_SELECTOR = "[data-open-dialog='recently-viewed-drawer']";

  let hydratePromise = null;
  let pendingTrigger = null;

  const readList = () => {
    try {
      const value = JSON.parse(localStorage.getItem(STORAGE_KEY));
      return Array.isArray(value) ? value : [];
    } catch (error) {
      return [];
    }
  };

  const paint = () => {
    const count = String(readList().length);

    document.querySelectorAll("[data-badge='recently_viewed']").forEach((elem) => {
      elem.textContent = count;
      elem.setAttribute("data-count", count);
    });
    dialog.setAttribute("data-recently-viewed-count", count);
  };

  const hydrate = () => {
    if (customElements.get("recently-viewed-component")) return Promise.resolve();
    if (hydratePromise) return hydratePromise;

    hydratePromise = Promise.all([
      loader.loadStylesheet(cssHref, "bolt-recently-viewed-css"),
      loader.loadScript(jsSrc, "bolt-recently-viewed-js"),
    ])
      .then(() => customElements.whenDefined("recently-viewed-component"))
      .then(() => {
        dialog.dataset.facadeBound = "true";
        document.removeEventListener("click", onFirstClick, true);
      })
      .catch((error) => {
        hydratePromise = null;
        dialog.dataset.facadeBound = "false";
        console.error("Recently viewed facade failed to load", error);
        throw error;
      });

    return hydratePromise;
  };

  const onFirstClick = async (event) => {
    const trigger = event.target.closest(CLICK_SELECTOR);
    if (!trigger) return;
    if (customElements.get("recently-viewed-component")) return;

    event.preventDefault();
    event.stopImmediatePropagation();
    pendingTrigger = trigger;

    try {
      await hydrate();
      const replay = pendingTrigger;
      pendingTrigger = null;
      replay?.click();
    } catch (error) {
      pendingTrigger = null;
    }
  };

  paint();
  document.addEventListener("click", onFirstClick, true);
  loader.onFirstInteraction(() => {
    hydrate();
  });
})();
